import React from 'react';
import DataDrivenArticlePage from '../components/articles/DataDrivenArticlePage';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'DC-DC Converter | AUTOXIUM';
const PAGE_DESCRIPTION =
  'A complete engineering reference to the EV DC-DC Converter ECU — the HV-to-LV power bridge that ' +
  'replaces the alternator: isolated power-stage topologies (Phase-Shifted Full Bridge, LLC Resonant, ' +
  'Dual Active Bridge), embedded control architecture (PWM, voltage/current mode control), CAN/LIN ' +
  'vehicle integration, the operating state machine, protection and DTC diagnostics, thermal management, ' +
  'EMC and functional safety (ISO 26262/ASIL), and bench/HIL/vehicle-level validation.';

const DcDcConverterEcuTechnicalArticlePage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);
  return <DataDrivenArticlePage slug="article-dcdc-converter-ecu" pdfSlug="dcdc-converter-ecu" />;
};

export default DcDcConverterEcuTechnicalArticlePage;
